stimulusApp.register(
  "star-rating",
  class extends Stimulus.Controller {
    static targets = ["star", "dependent", "dependentSelect"]
    static values = { selected: { type: Number, default: 0 } }

    connect() {
      const checked = this.element.querySelector(
        'input[name="place[stars]"]:checked:not([value="0"])',
      )
      if (checked) {
        this.selectedValue = parseInt(checked.value, 10)
        this.#applyFullStars()
        this.#showDependent(true)
      }
    }

    select(event) {
      const star = event.currentTarget
      const value = parseInt(star.dataset.value, 10)
      const radio = this.element.querySelector(
        `input[name="place[stars]"][value="${value}"]`,
      )
      if (radio) radio.checked = true
      this.selectedValue = value
      this.#applyFullStars()
      this.#showDependent(true)
    }

    unrate() {
      const radio = this.element.querySelector(
        'input[name="place[stars]"][value="0"]',
      )
      if (radio) radio.checked = true
      this.selectedValue = 0
      this.#applyFullStars()
      this.#showDependent(false)
    }

    mouseEnter(event) {
      const star = event.currentTarget
      const stars = this.starTargets
      const index = stars.indexOf(star)
      stars.forEach((s, i) => {
        if (i <= index) {
          s.classList.add("tmp_fs")
          s.classList.remove("tmp_es")
        } else {
          s.classList.remove("tmp_fs")
          s.classList.add("tmp_es")
        }
      })
    }

    mouseLeave() {
      this.starTargets.forEach((s) => {
        s.classList.remove("tmp_fs", "tmp_es")
      })
    }

    #applyFullStars() {
      this.starTargets.forEach((s) => {
        const value = parseInt(s.dataset.value, 10)
        s.classList.toggle("fullStar", value <= this.selectedValue)
      })
    }

    #showDependent(show) {
      if (this.hasDependentTarget) {
        this.dependentTarget.classList.toggle("hidden", !show)
      }
      if (this.hasDependentSelectTarget) {
        this.dependentSelectTarget.disabled = !show
      }
    }
  },
)
